export const isEdge = window.navigator.userAgent.indexOf('Edge') !== -1;

/**
 * Checks if the current environment is running on localhost
 */
export const isLocalhost = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
};

/**
 * Checks if a hostname is localhost
 */
export const isLocalhostHostname = (hostname: string): boolean => {
  return hostname === 'localhost' || hostname === '127.0.0.1';
};
